<template>
  <div v-if="order" class="userorder-singeorder">
    <div class="singleorder-header clearfix">
      <div class="single-order-header-time">{{ getHeaderTime(order.order_at) }}</div>
      <div class="single-order-header-id">OrderID: {{ order.order_no }}</div>
      <div class="single-order-header-price">Price: <span>${{ Number((order.price / 100).toFixed(2)) }}</span></div>
      <div class="single-order-header-countdown" v-if="order.state === 1">
        <span class="single-order-header-countdown-num">
          {{ countdown_text }}
        </span>&nbsp;remains
      </div>
      <div
        class="single-order-header-state"
        :class="{
          waiting: order.state === 1,
          paid: order.state === 2
        }">
        {{ state_text[order.state] }}
      </div>
    </div>
    <div class="singleorder-header multiple clearfix">
      <div class="clearfix">
        <div class="single-order-header-id">OrderID: {{ order.order_no }}</div>
        <div class="single-order-header-time">{{ getHeaderTime(order.order_at) }}</div>
        <div class="single-order-header-price">Price: <span>${{ Number((order.price / 100).toFixed(2)) }}</span></div>
      </div>
      <div>
        <div class="single-order-header-countdown" v-if="order.state === 1">
          <span class="single-order-header-countdown-num">
            {{ countdown_text }}
          </span>&nbsp;remains
        </div>
        <div
          class="single-order-header-state"
          :class="{
            waiting: order.state === 1,
            paid: order.state === 2
          }">
          {{ state_text[order.state] }}
        </div>
      </div>
    </div>
    <div class="singleorder-body">
      <picture class="singleorder-body-imgbox">
        <source :srcset="order.cover" type="image/webp">
        <img :src="order.cover" />
      </picture>
      <div class="singleorder-body-infobox">
        <div class="singleorder-body-title">
          {{ order.subject }}
        </div>
        <div class="singleorder-body-chapters">
          {{ order.total_chapter > 1 ? order.total_chapter + ' Lessons' : order.total_chapter + ' Lesson' }}
        </div>
        <div class="singleorder-body-divider"></div>
        <div class="singleorder-body-infos clearfix">
          {{ order.chapters.length > 1 ? order.chapters.length + ' lessons' : order.chapters.length + ' lesson' }}
          included in this order
          <span>Price: ${{ Number((order.price / 100).toFixed(2)) }}</span>
        </div>
      </div>
    </div>
    <div class="singleorder-footer" v-if="order.state === 1">
        <ct-button
          size="mini"
          type="text_secondary_light"
          :isLoading="cancelLoading"
          @click="clickCancel">Cancel</ct-button>
        <ct-button size="mini" type="primary" @click="goCheckout">Checkout</ct-button>
    </div>
    <div class="singleorder-footer" v-if="order.state === 2">
        <ct-button
          size="mini"
          type="text_secondary_light"
          @click="clickRefund">Refund</ct-button>
        <ct-button size="mini" type="primary" @click="goDetail">See the course</ct-button>
    </div>
    <ct-modal
      title="Refund Details"
      width="480px"
      @closed="refundModal=false"
      v-if="refundModal">
      <div class="refund-box" slot="body">
        <p class="refund-maininfo">We will return your money with the kind of currency which you paid with when purchasing the course.</p>
        <div class="refund-body">
          <div>
            <div class="refund-info-title">
              Order Price:
            </div>
            <div class="refund-info-content">
              ${{ refundInfo.total_cash }}
              <span>({{ refundInfo.total_chapter > 1 ? refundInfo.total_chapter + ' Lessons' :  refundInfo.total_chapter + ' Lesson'}})</span>
            </div>
          </div>
          <div>
            <div class="refund-info-title">
              <ct-icon name="question"></ct-icon>
              Non-refundable Price:
              <div class="refund-dropdown-info">
                This course can be refunded entirely before <span>{{ refundInfo.last_refund_time }}</span>, after that, only the lessons in the state of “To be broadcast” can be refunded.
              </div>
            </div>
            <div class="refund-info-content">
              ${{ refundInfo.notrefund_cash }}
              <span>({{ refundInfo.notrefund_chapter > 1 ? refundInfo.notrefund_chapter + ' Lessons' : refundInfo.notrefund_chapter + 'Lesson' }})</span>
            </div>
          </div>
        </div>
        <div class="underline"></div>
        <div class="refund-price-box">
          Refund Price: <span>${{ refundInfo.refund_cash }}</span>
        </div>
      </div>
      <div slot="footer" style="padding-top: 12px;">
        <ct-button type="text_secondary_light" @click="refundModal = false">Cancel</ct-button>
        <ct-button type="primary" :isLoading="refundConfirmLoading" @click="confirmRefund">Confirm</ct-button>
      </div>
    </ct-modal>
  </div>
</template>

<script>
import { orderState } from '@ca/constants'
import moment from 'moment'
import api from '../../../api'
import { mapGetters } from 'vuex'
import { vueAppPassportDomin } from '@ca/constants/variables'

export default {
  name: 'SingleOrder',
  props: {
    orderData: Object
  },
  data () {
    return {
      state_text: {
        1: '· Waiting for checkout',
        2: 'Paid',
        3: 'Time out',
        4: 'Refunding',
        5: 'Refunded',
        6: 'Canceled'
      },
      countdown_text: 'xx:xx',
      has_expired: false,
      timeid: undefined,
      order: undefined,
      cancelLoading: false,
      refundLoading: false,
      refundModal: false,
      refundConfirmLoading: false,
      refundInfo: {}
    }
  },
  mounted () {
    this.order = this.formatData(this.orderData)
    if (this.order.state === 1) {
      this.startTimeCountDown()
    }
  },
  destroyed () {
    clearInterval(this.timeid)
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    formatData (obj) {
      let a = JSON.parse(JSON.stringify(obj))
      a.cover = a.cover || this.defaultCover
      return a
    },
    getHeaderTime (time) {
      return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    startTimeCountDown () {
      let begin = this.order.order_at * 1000
      let end = begin + (30 * 60 * 1000)
      if (new Date().getTime() > end) {
        this.order.state = orderState['TIMEOUT_PAY']
        this.has_expired = true
        clearInterval(this.timeid)
      } else {
        this.has_expired = false
        this.timeid = setInterval(() => {
          let a = new Date().getTime()
          let b = new Date(end).getTime()
          if (a >= b) {
            clearInterval(this.timeid)
            this.has_expired = true
            this.order.state = orderState['TIMEOUT_PAY']
            return
          }
          let m = parseInt((b - a) / 1000 / 60) + ''
          m = m.length < 2 ? '0' + m : m
          let s = parseInt(((b - a) / 1000) - m * 60) + ''
          s = s.length < 2 ? '0' + s : s
          this.countdown_text = m + ':' + s
        }, 1000)
      }
    },
    goDetail () {
      this.$router.push({
        name: 'userCourseDetail',
        params: {
          goods_id: this.orderData.goods_id
        }
      })
    },
    goCheckout () {
      this.$router.push({
        name: 'payPage',
        params: {
          order_no: this.order.order_no
        }
      })
    },
    clickCancel () {
      if (this.cancelLoading) return
      this.cancelLoading = true
      api.cancelOrder({
        data: {
          order_no: this.order.order_no
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.order.state = orderState['CANCELED_PAY']
          this.$toast({
            type: 'success',
            message: 'This order has been Canceled.'
          })
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops…Something is wrong, please try again later.'
          })
        }
        this.cancelLoading = false
      }, err => {
        console.log(err)
        this.$toast({
          type: 'error',
          message: 'Oops…Something is wrong, please try again later.'
        })
        this.cancelLoading = false
      })
    },
    clickRefund () {
      if (this.refundLoading) return
      if (!this.isAuthenticated) {
        window.location.href = vueAppPassportDomin + '/login?return_url=' + window.location.href
        return
      }
      this.refundLoading = true
      api.getRefundInfo({
        params: {
          order_no: this.order.order_no,
          product_type: this.order.product_type
        }
      }).then(res => {
        let text = 'Oops, something went wrong, please try again later.'
        this.refundLoading = false
        if (res.data && res.data.code === 1) {
          this.goRefund(res.data.data)
          return
        } else if (res.data.code === 90309) {
          text = 'This order has been refunded. Please check your Alipay or Wechat account.'
        } else if (res.data.code === 90310) {
          text = 'This order has been in the refund procedure. Normally, it takes about 1 to 5 workdays to return the money back.'
        } else if (res.data.code === 90311) {
          text = 'Sorry, the course in this order is non-refundable.'
        } else if (res.data.code === 90312) {
          text = 'Sorry, none of the lessons in the course of this order is in the state of “To be broadcast”, so it can be refunded.'
        } else if (res.data.code === 90315) {
          text = 'Sorry, unknown error.'
        }
        this.$confirm({
          title: 'Notice',
          message: text,
          cancelButton: false,
          confirmButtonText: 'Got it',
          handleAction: (a, b) => {
            b()
          }
        })
      })
    },
    goRefund (obj) {
      this.refundInfo = {
        total_cash: Number((obj.total_cash / 100).toFixed(2)),
        refund_cash: Number((obj.refund_cash / 100).toFixed(2)),
        notrefund_cash: Number(((obj.total_cash - obj.refund_cash) / 100).toFixed(2)),
        total_chapter: this.order.chapters.length,
        notrefund_chapter: this.order.chapters.length - obj.refund_count,
        last_refund_time: moment(obj.last_refund_time * 1000).format('HH:mm MMM Do, YYYY')
      }
      this.refundModal = true
    },
    confirmRefund () {
      if (this.refundConfirmLoading) return
      this.refundConfirmLoading = true
      api.refundOrder({
        data: {
          order_no: this.order.order_no,
          product_type: this.order.product_type
        }
      }).then(res => {
        this.refundConfirmLoading = false
        this.refundModal = false
        if (res.data && res.data.code === 1) {
          this.order.state = orderState['REFUND_OK']
          this.$confirm({
            title: 'Refund Complete',
            message: 'We have completed the refund procedure! The money will return back to your Wechat Pay / Alipay / credit card account which you paid with, but may not achieve immediately. Please check your payment account later.',
            cancelButton: false,
            confirmButtonText: 'Got it',
            handleAction: (a, b) => {
              b()
            }
          })
        } else if (res.data.code === 90310) {
          this.order.state = orderState['REFUND']
          this.$confirm({
            title: 'Refund request received',
            message: 'We\'ve received your refund request and will accomplish refund as soon as possible, but the refund process normally takes 3 to 5 workdays. When finished, we will inform you with email.',
            cancelButton: false,
            confirmButtonText: 'Got it',
            handleAction: (a, b) => {
              b()
            }
          })
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops…For some unpredictable reason, this order can’t be refunded now, please try again later.'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .userorder-singeorder {
    margin-bottom: 24px;
    border:1px solid rgba(239,244,250,1);
    border-radius:2px;
    .singleorder-header {
      background:rgba(247,251,255,1);
      height: 38px;
      padding: 8px 24px;
      border-bottom: 1px solid rgba(239,244,250,1);
      .single-order-header-time {
        float: left;
        font-size:14px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(163,177,191,1);
        line-height:22px;
        margin-right: 48px;
      }
      .single-order-header-id {
        float: left;
        font-size:14px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(163,177,191,1);
        line-height:22px;
        margin-right: 48px;
      }
      .single-order-header-price {
        float: left;
        font-size:14px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(163,177,191,1);
        line-height: 22px;
        user-select: none;
        span {
          color: #1A3D5E;
          user-select: text;
        }
      }
      .single-order-header-state {
        float: right;
        font-size:14px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(163,177,191,1);
        line-height:22px;
        &.paid {
          color: #1A3D5E;
        }
        &.waiting {
          color: #37CAD7;
        }
      }
      .single-order-header-countdown {
        float: right;
        margin-left: 12px;
        font-size:12px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:#A3B1BF;
        line-height:22px;
        .single-order-header-countdown-num {
          color: #F57373;
        }
      }
      &.multiple {
        display: none;
        height: 70px;
        .single-order-header-id {
          float: none;
          margin-bottom: 8px;
          font-size:12px;
        }
        .single-order-header-price {
          line-height: 22px;
        }
      }
    }
    @media screen and (max-width: 1200px) {
      .singleorder-header {
        display: none;
        &.multiple {
          display: flex;
          justify-content: space-between;
          align-items: center;
          > div {
            flex: 1;
          }
        }
      }
    }
    .singleorder-body {
      display: flex;
      width: 100%;
      padding: 24px;
      .singleorder-body-imgbox {
        width: 238px;
        margin-right: 24px;
        height: 134px;
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
      .singleorder-body-infobox {
        flex: 1;
        overflow: hidden;
        .singleorder-body-title {
          font-size:20px;
          font-family:SFProDisplay-Medium,SFProDisplay;
          font-weight:500;
          color:rgba(26,61,94,1);
          line-height:24px;
          padding-bottom: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          word-break: break-word;
        }
        .singleorder-body-chapters {
          padding:8px;
          display: inline-block;
          width: auto;
          margin-bottom: 24px;
          background:rgba(239,244,250,1);
          border-radius:14px;
          font-size:12px;
          font-family:SFProText-Regular,SFProText;
          font-weight:400;
          color:rgba(26,61,94,1);
          line-height:12px;
        }
        .singleorder-body-divider {
          border-top: 1px solid #E8EBEE;
          margin-bottom: 15px;
        }
        .singleorder-body-infos {
          font-size:14px;
          font-family:SFProText-Regular,SFProText;
          font-weight:400;
          color:rgba(118,139,158,.8);;
          line-height:22px;
          span {
            float: right;
          }
        }
      }
    }
    .singleorder-footer {
      padding: 8px 24px 24px;
      text-align: right;
    }
    .refund-box {
      .refund-maininfo {
        font-size:14px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(54,85,114,1);
        line-height:22px;
        margin-bottom: 30px;
      }
      .refund-body {
        display: flex;
        justify-content: space-between;
        height: 60px;
        padding-bottom: 16px;
        >div {
          flex: 1;
          text-align: left;
          .refund-info-title {
            font-size:14px;
            font-family:SFProText-Regular,SFProText;
            font-weight:400;
            color:rgba(163,177,191,1);
            line-height:14px;
            margin-bottom: 12px;
            position: relative;
            .refund-dropdown-info {
              display: none;
              position: absolute;
              top: -114px;
              right: 0;
              width: 416px;
              padding: 16px;
              font-size:14px;
              font-family:SFProText-Regular,SFProText;
              font-weight:400;
              text-align: left;
              color:rgba(26,61,94,1);
              line-height:22px;
              background:rgba(247,251,255,1);
              border:1px solid rgba(239,244,250,1);
              span {
                font-size: 16px;
              }
              &::before {
                content: '';
                display: block;
                width: 16px;
                height: 16px;
                background:rgba(247,251,255,1);
                border-left: 1px solid rgba(239,244,250,1);
                border-bottom: 1px solid rgba(239,244,250,1);
                position: absolute;
                right: 65px;
                bottom: -8px;
                transform: rotate(-45deg);
              }
            }
          }
          .refund-info-content {
            font-size:14px;
            font-family:SFProText-Medium,SFProText;
            font-weight:500;
            color:rgba(26,61,94,1);
            line-height:14px;
            span {
              font-size:14px;
              font-family:PingFangSC-Regular,PingFangSC;
              font-weight:400;
              color:rgba(164,177,191,1);
            }
          }
          &:last-child {
            text-align: right;
            .refund-info-title:hover {
              .refund-dropdown-info {
                display: block;
              }
            }
          }
        }
      }
      .underline {
        border-top: 1px solid rgba(239,244,250,1);
        margin-bottom: 16px;
      }
      .refund-price-box {
        text-align: right;
        font-size:14px;
        font-family:SFProText-Medium,SFProText;
        font-weight:400;
        color:rgba(26,61,94,1);
        line-height:16px;
        span {
          font-weight:500;
          font-size: 16px;
        }
      }
    }
  }
</style>
